
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Define valid tag values based on the Supabase enum
const VALID_TAGS = [
  "frontend", 
  "backend", 
  "fullstack", 
  "devops", 
  "mobile", 
  "ai", 
  "data", 
  "security", 
  "leadership", 
  "architecture"
] as const;

type ValidTag = typeof VALID_TAGS[number];

/**
 * Service for creating new interviews
 */
export class InterviewCreationService {
  /**
   * Create a new interview directly
   */
  static async createInterview(interviewData: {
    intervieweeName: string;
    title: string;
    company: string;
    context: string;
    contextUrl?: string;
    question: string;
    answer: string;
    tags: string[];
    photoUrl?: string;
    publication_status?: string;
  }): Promise<string | null> {
    try {
      console.log('Creating interview:', interviewData);
      
      // Filter the tags to only include valid ones from our enum
      const validTags = interviewData.tags
        .filter(tag => VALID_TAGS.includes(tag as ValidTag)) as ValidTag[];
      
      console.log('Filtered valid tags:', validTags);
      
      const { data, error } = await supabase
        .from('interviews')
        .insert({
          interviewee_name: interviewData.intervieweeName,
          title: interviewData.title,
          company: interviewData.company,
          context: interviewData.context,
          context_url: interviewData.contextUrl || null,
          question: interviewData.question,
          answer: interviewData.answer,
          tags: validTags,
          photo_url: interviewData.photoUrl,
          publication_status: interviewData.publication_status || 'pending'
        })
        .select('id')
        .single();
      
      if (error) {
        console.error('Error creating interview:', error);
        throw new Error(`Failed to create interview: ${error.message}`);
      }
      
      return data?.id || null;
    } catch (error) {
      console.error('Error in createInterview:', error);
      throw error;
    }
  }
}
